import { filter, Subscription } from 'rxjs';
import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { MediaSummaryModel } from '../../models/content-library-media-summary.model';
import { MediaModel } from '../../../../Common/ContentLibrary/models/content-library-media.model';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { formatFileSize } from '../../../../Common/Misc/helpers/formatting/media.helper';
import { resolveFileIcon } from '../../../Misc/helpers/file/fileIcon.helper';

@Component({
    selector: 'agpr-content-library-item',
    templateUrl: './content-library-item.html',
    styleUrls: ['./content-library-item.scss'],
    standalone: false
})

export class ContentLibraryItemComponent implements OnInit {
    @Input() id: string;
    @Input() item!: MediaSummaryModel;
    @Input() isSelected = false;
    @Input() itemDetails: MediaModel;
    @Input() showCheckbox = true;
    @Input() showRemoveButton = false;
    @Input() isCurrentlySelected = false;
    @Input() currentlySelectedItems: MediaSummaryModel[] = [];
    @Input() singleSelect = false;

    @Output() selectionChange = new EventEmitter<MediaSummaryModel>();
    @Output() itemSelected = new EventEmitter<MediaSummaryModel>();
    @Output() clearSelectionRequested = new EventEmitter<void>();

    @ViewChild('itemElement') itemElement: ElementRef;

    subscriptions: Subscription[] = [];
    hasError = false;
    preferences: PreferencesModel = new PreferencesModel();
    dateFormat: string;
    formatFileSize = formatFileSize;

    constructor(
        private currentUserStateService: CurrentUserStateService
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.preferences = prefs;
                this.dateFormat = prefs.getDateFormatString(true, true, true);
            }),
        );
    }

    getFileIcon(mimeType: string): string {
        return resolveFileIcon(mimeType);
    }

    handleImageError(event: Event, mimeType: string): void {
        const img = event.target as HTMLImageElement;
        const span = document.createElement('span');
        span.classList.add('thumbnail-container-default-icon');
        span.classList.add(this.getFileIcon(mimeType));
        img.replaceWith(span);
    }

    onCheckboxClick(checked: boolean): void {
        this.item.isSelected = checked;
        this.selectionChange.emit(this.item);
    }

    unSelect(): void {
        this.clearSelectionRequested.emit();
    }
    onClick(): void {
        this.itemSelected.emit(this.item);
    }
}
